module.exports = __webpack_public_path__ + "img/pic_light@3x.c2d06349.png";